import { TabName } from "src/components/projetos/personalizados";
import { TabName as DimensionadoTabName } from "src/components/projetos/dimensionados";
import { dimensionadoStore$, personalizadoStore$, servicoCodeModalIsOpenedStore$, servicoInformationModalIsOpenedStore$, vendedorInternoModalIsOpenedStore$ } from "./store";
import { Option } from "src/components/projetos/types";
import { CalcularPaybackRoiProps } from "src/providers/ProjetosProvider";

export const setPersonalizadoTabDisabledStatus = (tab: TabName, status: boolean) => {
  return personalizadoStore$.next({ ...personalizadoStore$.value, tabs: { ...personalizadoStore$.value.tabs, [tab]: { ...personalizadoStore$.value.tabs[tab], disabled: status } } })
}

export const setPersonalizadoTabDoneStatus = (tab: TabName, status: boolean) => {
  return personalizadoStore$.next({ ...personalizadoStore$.value, tabs: { ...personalizadoStore$.value.tabs, [tab]: { ...personalizadoStore$.value.tabs[tab], done: status } } })
}

export const setDimensionadoDrawerStatus = (status: boolean) => {
  return dimensionadoStore$.next({ ...dimensionadoStore$.value, drawerIsOpened: status })
}

export const setDimensionadoTabDisabledStatus = (tab: DimensionadoTabName, status: boolean) => {
  return dimensionadoStore$.next({ ...dimensionadoStore$.value, tabs: { ...dimensionadoStore$.value.tabs, [tab]: { ...dimensionadoStore$.value.tabs[tab], disabled: status } } })
}

export const setDimensionadoTabDoneStatus = (tab: DimensionadoTabName, status: boolean) => {
  return dimensionadoStore$.next({ ...dimensionadoStore$.value, tabs: { ...dimensionadoStore$.value.tabs, [tab]: { ...dimensionadoStore$.value.tabs[tab], done: status } } })
}

export const setServicoCodeModalStatus = (status: boolean) => {
  return servicoCodeModalIsOpenedStore$.next(status)
}

export const setServicoInformationModalStatus = (status: boolean) => {
  return servicoInformationModalIsOpenedStore$.next(status)
}

export const setVendedorInternoModalStatus = (status: boolean, onConfirm: (vendedor?: Option<number>) => void = () => {} ) => {
  return vendedorInternoModalIsOpenedStore$.next({ status, onConfirm })
}

export const setRoiPaybackModalStatus = (status: boolean, payload: { projetoId?: number; calculateData?: CalcularPaybackRoiProps } | null = null) => {
  return dimensionadoStore$.next({ ...dimensionadoStore$.value, roiPaybackModalStatus: { isOpened: status, payload } })
}